import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IMessage } from '../../../models/chatbot.interfaces';
import { Store } from '@ngxs/store';
import { ChatbotState } from '../../../state/chatbot.state';

@Component({
  selector: 'hf-messages-template',
  templateUrl: './messages-template.component.html',
  styleUrls: ['./messages-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessagesTemplateComponent {
  @Input() message: IMessage;
  @Input() role: 'USER' | 'ASSISTANT' = 'ASSISTANT';

  constructor(
    private snackBar: MatSnackBar,
    private readonly store: Store
  ) {}

  @HostBinding('class.user') get isUser() {
    return this.role === 'USER';
  }

  @HostBinding('class.assistant') get isAssistant() {
    return this.role === 'ASSISTANT';
  }

  get isStreaming(): boolean {
    return this.message?.status === 'streaming';
  }

  get showDelivered(): boolean {
    const s = this.message?.status;
    const thinking = this.store.selectSnapshot(ChatbotState.isChatbotThinking);
    // undefined for previously sent messages from the conversation history (status is not sent from the BE)
    return s === 'delivered' || s === undefined || (this.message?.type === 'ASSISTANT' && thinking);
  }

  public onCopied() {
    this.snackBar.open('Copied to clipboard!', '', { duration: 1200, panelClass: ['copied-snackbar'] });
  }

  getRenderedContent(message: IMessage): string {
    return message.content || '';
  }
}
